// extracted by mini-css-extract-plugin
export default {"tag":"_03B3b","principle":"_3aHKw"};